import React from 'react';
import { Link } from 'react-router-dom';
import { RemoveRedEye, ArrowBack } from '@material-ui/icons';

import './css/AnchorLiveFeedStatusBar.mobile.css';


const AnchorLiveFeedStatusBar = ({ roomCount, isInGroupShow, anchorDetails }) => (
  <div className={`${isInGroupShow && (anchorDetails.name || anchorDetails.nickname) ? 'broadcast-viewer-status-bar broadcast-viewer-status-bar-participant' : 'broadcast-viewer-status-bar'}`}>
    <Link className="back-arrow-small" to="/naked-news-anchors">
      <ArrowBack fontSize="large" />
    </Link>
    <div className="live">
      <span className="live-dot" /> LIVE
    </div>
    <div className="viewers-count">
      <RemoveRedEye />&nbsp;
      <span className="number">{roomCount}</span>
    </div>
  </div>
);

export default AnchorLiveFeedStatusBar;
